import styled from 'styled-components';

export const StyledBubble = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
